import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, formatDistanceToNowStrict, parseISO } from "date-fns";

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export const fmtDate = (v: string | null | undefined, pattern = "d MMM yyyy"): string => (v ? format(parseISO(v), pattern) : "—");
export const fmtDateTime = (v: string | null | undefined): string => (v ? format(parseISO(v), "d MMM yyyy, HH:mm") : "—");
export const fmtAgo = (v: string | null | undefined): string => (v ? formatDistanceToNowStrict(parseISO(v), { addSuffix: true }) : "—");
export const fmtBytes = (n: number | null | undefined): string => {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};
export const fmtNumber = (n: number | null | undefined, digits = 0): string => (n == null ? "—" : n.toLocaleString("en-GB", { maximumFractionDigits: digits }));
export const fmtMoney = (n: number | null | undefined, currency = "GBP"): string => (n == null ? "—" : n.toLocaleString("en-GB", { style: "currency", currency }));
export const titleCase = (s: string): string => s.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const initials = (s: string): string =>
  s
    .split(/\s+/)
    .map((p) => p[0] ?? "")
    .join("")
    .slice(0, 2)
    .toUpperCase();

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function copyText(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}
